import React from "react";
import Navbar from "../components/Navbar";

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#05050a] text-white">
      <Navbar />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-10" data-testid="terms-page">
        <div className="font-mono-cosmic text-[10px] tracking-[0.3em] uppercase text-[#b026ff] mb-2">
          // LEGAL · TERMS
        </div>
        <h1 className="font-heading text-4xl sm:text-5xl mb-2">Terms of Service</h1>
        <div className="font-mono-cosmic text-[10px] tracking-[0.25em] uppercase text-white/45 mb-8">
          Last updated · 2026-05-27
        </div>

        <section className="space-y-6 text-white/80 leading-relaxed">
          <p>
            By creating a Cosmic Worm Breaker account, you agree to the rules below.
            We've kept this short and human. Read it once and you'll know what you can and can't do.
          </p>

          <div>
            <h2 className="font-heading text-xl mb-2 text-white">1. The deal</h2>
            <p className="text-sm">
              We give you a fun space-themed brick breaker. You play, you progress, you can buy cosmetic ball skins ($0.99 each)
              and earn in-game Moonstones through gameplay. <b>Moonstones have no real-money value</b> and can never be cashed out.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-xl mb-2 text-white">2. Your account</h2>
            <ul className="list-disc list-inside space-y-1 text-sm">
              <li>One account per person. Keep your password safe.</li>
              <li>Don't impersonate anyone or pick offensive callsigns. We may rename or ban offenders.</li>
              <li>You're 13+ to play.</li>
            </ul>
          </div>

          <div>
            <h2 className="font-heading text-xl mb-2 text-white">3. Fair play</h2>
            <ul className="list-disc list-inside space-y-1 text-sm">
              <li>No cheating, score manipulation, bots, or exploiting bugs for ranked rewards.</li>
              <li>Don't try to reverse-engineer the backend, brute-force endpoints, or DOS the service.</li>
              <li>We may ban accounts that we believe are gaming the leaderboards or wager system.</li>
            </ul>
          </div>

          <div>
            <h2 className="font-heading text-xl mb-2 text-white">4. Purchases & refunds</h2>
            <ul className="list-disc list-inside space-y-1 text-sm">
              <li>Cosmetic purchases are processed via Stripe in your local currency.</li>
              <li>Digital goods are non-refundable EXCEPT in cases of unauthorized charges or technical failure that prevented delivery. Email <a href="mailto:support@cosmic.space" className="text-[#b026ff] underline">support@cosmic.space</a> for refund requests.</li>
              <li>If we issue a refund, the corresponding skin will be revoked from your account.</li>
            </ul>
          </div>

          <div>
            <h2 className="font-heading text-xl mb-2 text-white">5. Wagers & bounties</h2>
            <p className="text-sm">
              Players can stake Moonstones (in-game currency only) on challenges between friends.
              <b> This is not gambling.</b> Moonstones have no real-money value, cannot be purchased with cash, and cannot be exchanged for cash.
              Stakes are escrowed, returned on expiry, and paid to the winner of the challenge.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-xl mb-2 text-white">6. Content you submit</h2>
            <p className="text-sm">
              Pilot callsigns, community-built levels, and chat messages — you own them, but you grant us a license to display them
              in-game and on leaderboards. Hate speech, doxxing, or NSFW content will be removed and may result in a ban.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-xl mb-2 text-white">7. Service availability</h2>
            <p className="text-sm">
              We aim for 99.5% uptime but provide no SLA. We may need to take the service down for maintenance,
              fix bugs that corrupt leaderboards, or roll back state in emergencies. Best-effort always.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-xl mb-2 text-white">8. Termination</h2>
            <p className="text-sm">
              You can delete your account anytime (see Privacy Policy). We may suspend or terminate accounts that violate these terms.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-xl mb-2 text-white">9. Liability</h2>
            <p className="text-sm">
              The game is provided "as is". To the extent allowed by law, we're not liable for indirect damages
              (lost saves, lost ranking position, etc.). Our total liability is capped at what you paid us in the last 12 months.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-xl mb-2 text-white">10. Contact</h2>
            <p className="text-sm">
              Support: <a href="mailto:support@cosmic.space" className="text-[#b026ff] underline">support@cosmic.space</a>
            </p>
          </div>
        </section>
      </main>
    </div>
  );
}
